module.exports = __webpack_public_path__ + "static/media/mytoken_admin_manage.9e416ca6.png";